<template>
  <div class="min-h-[60vh] flex items-center justify-center" role="status" aria-live="polite">
    <div class="text-center">
      <div class="inline-block w-16 h-16 rounded-2xl bg-q4cl-primary text-white text-2xl font-bold flex items-center justify-center mb-4" aria-hidden="true">Q4</div>
      <h1 class="text-2xl font-bold text-q4cl-primary mb-1">{{ $t('セキュア問診票') }}</h1>
      <p class="text-q4cl-muted">{{ $t('起動しています...') }}</p>
      <div class="animate-spin rounded-full h-8 w-8 border-4 border-q4cl-border border-t-q4cl-accent mx-auto mt-4" aria-hidden="true"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Start',
  setup() {
    const router = VueRouter.useRouter();
    const route = VueRouter.useRoute();
    Vue.onMounted(() => {
      setTimeout(() => {
        router.replace({ path: '/', query: route.query });
      }, 600);
    });
    return {};
  }
};
</script>
